import { Component, OnInit, HostListener } from '@angular/core';
import { CoreService } from '../core.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { NgClass, NgIf, NgFor, UpperCasePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'


@Component({
	selector: 'app-chat',
	imports: [

		FormsModule, ReactiveFormsModule,
		NgClass, NgIf, NgFor,


	],
	templateUrl: './chat.component.html',
	styleUrl: './chat.component.scss'
})
export class ChatComponent {

	constructor( public core: CoreService, private sanitizer:DomSanitizer ){}

	countryCodeToFlag( code: string ): string {
		code = code.toUpperCase()
		if (code == "XX") //Unkown Location
			return String.fromCodePoint(128125)
		return code.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0)+127397) );
	}
	unique_messages = new Set(); //timestamp -> msg
	messages: any[] = [];
	app = document.querySelector('app-chat');
	get pinned(){ return this.core.channel && this.core.channel.pinned && ( this.core.channel.pinned.id == this.discared_pin_id ? null : this.core.channel.pinned ) }
	discared_pin_id: number = null

	@HostListener('scroll', ['$event'])
	onScroll(e) {
		let nodes = this.app.querySelectorAll('.messages > .message:not(.sticky)');
		if( nodes.length == 0 ) return;

		let lm  = nodes.item(nodes.length-1);
		let was = this.core.app_component.scroll_locked;
		let is  = this.core.app_component.scroll_locked = 0 - this.app.clientHeight - this.app.scrollTop <= 150 - lm['offsetTop'];
		if(!was && is) this.core.app_component.unread_count = 0;
	}
	smartScroll(){
		setTimeout(() => {
			if( this.core.app_component.scroll_locked && !this.core.app_component.scroll_manual )
				this.scrollTo(-5);
		}, 10);
	}
	toggleStick(m){
		m.sticky = !m.sticky;
		this.smartScroll();
	}
	scrollTo(number){
		this.app.scrollTo({ 'top':this.app.scrollHeight - number, 'behavior':'smooth' });
	}

	ngOnInit(): void {


		this.core.message_event.subscribe((data)=>{
			if( data['deleted_msgs'] )
				for( let msg_id of data['deleted_msgs'] ){
					this.unique_messages.add( msg_id );
					if( this.core.truesight )
						for( let msg of this.messages ){
							if( msg['id'] == msg_id )
								msg['is_deleted'] = true;
						}

					else
						this.messages = this.messages.filter((msg)=>{ return msg['id'] !== msg_id })
				}


			if( data['msgs'] ){
				for( let msg of data['msgs'] ){

					if( msg['id'] && this.unique_messages.has(msg['id']) )
						continue

					//msg['text'] = window['twemoji'].parse(msg['text'])
					msg['text'] = this.sanitizer.bypassSecurityTrustHtml(msg['text'])

					//if( msg['country_code'] )
					//	msg['country_code'] = this.sanitizer.bypassSecurityTrustHtml(window['twemoji'].parse(this.countryCodeToFlag(msg['country_code'])))

					msg['timeago'] = this.core.toTimeAgo( msg['timestamp'] )

					if( msg['id'] )
						this.unique_messages.add( msg['id'] )

					if( !msg['whisper_to'] || msg['whisper_to'] == (this.core.personality && this.core.personality.id) ) //Just in case!!
						this.messages.push(msg)

					if( !this.core.app_component.scroll_locked )
						this.core.app_component.unread_count += 1;

					if( ['mod', 'admin'].indexOf( msg['role'] ) == -1 && msg['personality_id'] && this.core.premium_users.has(msg['personality_id']) )
						msg['premium'] = true
					else
						msg['premium'] = false

				}
				this.messages.sort((a,b)=>{return a['timestamp'] - b['timestamp'] });
				if( this.messages.length > 350 )
					this.messages = this.messages.slice(-300)

				this.smartScroll();
			}
		})
		this.core.scroll_event.subscribe((msg_id)=>{
			if( msg_id === null )
				this.scrollTo(0)
		})
		this.core.clear_event.subscribe(()=>{
			this.unique_messages = new Set();
			this.messages = [];
		})

		setInterval( ()=>{ this.update_timeago() }, 10000 )
	}

	update_timeago(){
		for( let msg of this.messages )
			msg['timeago'] = this.core.toTimeAgo( msg['timestamp'] );
	}

	insert_message_id(msg){
		this.core.insert_event.emit( this.core.app_component.message.startsWith("/") ? `<M-${msg.id}>` : (`@${msg.username}` + String.fromCodePoint(8205)) )
	}





	customClick(e){
		var cmd = e.target.getAttribute('data-cmd');
		if( cmd ) this.core.smartSend({"cmd": cmd});
	}

}
